export default __webpack_public_path__ + "static/media/tshirt.af272425.svg";